import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import PiecePerdu from "./pages/PiecePerdu";
import PieceRamace from "./pages/PieceRamace";
import "bootstrap/dist/css/bootstrap.min.css";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import CreateAdmin from "./pages/CreateAdmin";
import MesDeclarations from "./pages/MesDeclarations";

const AppRoutes = () => {
  const location = useLocation();
  const path = location.pathname || "";
  const isAdminShell = path.startsWith("/admin");
  const isAdminLogin = path.startsWith("/admin-login");
  const isHome = path === "/";

  const routes = (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/piece-perdu" element={<PiecePerdu />} />
      <Route path="/piece-ramace" element={<PieceRamace />} />
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/create-admin" element={<CreateAdmin />} />
      <Route path="/mes-declarations" element={<MesDeclarations />} />
    </Routes>
  );

  if (isAdminShell || isAdminLogin || isHome) {
    return routes;
  }

  return <div className="App">{routes}</div>;
};

const App = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default App;
